/* Fabrinique Compat DB — Merger */
window.FAB_COMPAT_DB=(function(){
  var p1=window.FAB_COMPAT_PART1||[];
  var p2=window.FAB_COMPAT_PART2||[];
  var wl=window.FAB_COMPAT_WAITLIST||[];
  var db=p1.concat(p2).concat(wl);

  /* Exact-fit PDP routing overrides.
     Birkin 25/30/35 are separate Shopify products; do not route them
     through the legacy combined Birkin product. */
  var exactFitHandles={
    'hermes/birkin-25':'purse-pillow-insert-hermes-birkin-25',
    'hermes/birkin-30':'purse-pillow-insert-hermes-birkin-30',
    'hermes/birkin-35':'purse-pillow-insert-hermes-birkin-35',
    'hermes/kelly-25':'purse-pillow-insert-hermes-kelly-25',
    'hermes/kelly-28':'purse-pillow-insert-hermes-kelly-28',
    'hermes/kelly-32':'purse-pillow-insert-hermes-kelly-32',
    'louis-vuitton/speedy-25':'purse-pillow-inserts-for-louis-vuitton-speedy-25',
    'louis-vuitton/speedy-30':'purse-pillow-inserts-for-louis-vuitton-speedy-30',
    'louis-vuitton/speedy-35':'purse-pillow-inserts-for-louis-vuitton-speedy-35',
    'louis-vuitton/keepall-45':'purse-pillow-inserts-for-louis-vuitton-keepall-45',
    'louis-vuitton/keepall-50':'purse-pillow-inserts-for-louis-vuitton-keepall-50',
    'louis-vuitton/keepall-55':'purse-pillow-inserts-for-louis-vuitton-keepall-55',
    'louis-vuitton/keepall-60':'purse-pillow-inserts-for-louis-vuitton-keepall-60',
  };
  db.forEach(function(bag){
    var key=bag.brandSlug+'/'+bag.modelSlug;
    if(exactFitHandles[key]){
      bag.exactFit=true;
      bag.size='exact';
      bag.exactFitHandle=exactFitHandles[key];
      bag.comingSoon=false;
    }
  });

  var sizeOverrides={'dior/book-tote-large':'xl','saint-laurent/sac-de-jour-large':'xl'};
  var ensureBags=[{brand:'Dior',brandSlug:'dior',model:'Book Tote Large',modelSlug:'book-tote-large',size:'xl',exactFit:false,exactFitHandle:null,needsVerif:false,comingSoon:false,related:['book-tote-medium']},{brand:'Saint Laurent',brandSlug:'saint-laurent',model:'Sac de Jour Large',modelSlug:'sac-de-jour-large',size:'xl',exactFit:false,exactFitHandle:null,needsVerif:false,comingSoon:false,related:[]}];
  ensureBags.forEach(function(bag){var exists=db.some(function(x){return x.brandSlug===bag.brandSlug && x.modelSlug===bag.modelSlug;});if(!exists){db.push(bag);}});
  db.forEach(function(bag){var key=bag.brandSlug+'/'+bag.modelSlug;if(sizeOverrides[key] && !bag.exactFit && !bag.comingSoon){bag.size=sizeOverrides[key];bag.needsVerif=false;}});

  return db;
})();
